import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 12a2 2 0 1 0 4 0a9 9 0 1 0 -2.987 6.697","key":"svg-0"}],["path",{"d":"M7 12a5 5 0 1 0 10 0a5 5 0 1 0 -10 0","key":"svg-1"}],["path",{"d":"M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-2"}],["path",{"d":"M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-3"}]]

const IconBrandMailgun = createReactComponent('outline', 'brand-mailgun', 'BrandMailgun', __iconNode);

export default IconBrandMailgun;